<template>
  <div class="vx-row">
    <div class="vx-col ml-auto mr-auto mb-base lg:w-9/12 w-full">
      <h2>Termijnbedragadvies</h2>
    </div>
    <div
      class="vx-col mb-2 ml-auto mr-auto w-full"
      v-if="advise && contractDetails.recurring_payment"
    >
      <recurring-amount-advise
        :advise="advise"
        :current="contractDetails.recurring_payment.total_incl_vat"
      />
    </div>
  </div>
</template>

<script>
import axios from "../axios";
import recurringAmountAdvise from "../components/contracts/recurringAmountAdvise.vue";
export default {
  props: ["contractId", "baseOnCurrentEac"],
  components: { recurringAmountAdvise },
  data() {
    return { advise: {}, contractDetails: {} };
  },
  async mounted() {
    await this.getContractDetails(this.contractId);
    let baseOnCurrentEac = this.baseOnCurrentEac
      ? this.baseOnCurrentEac
      : this.contractDetails.has_conventional_meter &&
        this.contractDetails.contract_type != 4 &&
        !this.contractDetails
          .has_sent_recurring_amount_advise_metering_recently;
    await this.getAdvise(this.contractId, baseOnCurrentEac);
  },

  methods: {
    async getAdvise(contractId, baseOnCurrentEac) {
      let response = await axios().get(
        `/api/contracts/${contractId}/advised_recurring_amount?baseOnCurrentEac=${baseOnCurrentEac}`
      );
      this.advise = response.data;
    },
    async getContractDetails(contractId) {
      let response = await axios().get(`/api/contracts/${contractId}`);
      this.contractDetails = response.data;
    }
  }
};
</script>

<style></style>
